/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Warehouse_BagsInputs */

const en_cargo_warehouse_bags = /** @type {(inputs: Cargo_Warehouse_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse Bags`)
};

const es_cargo_warehouse_bags = /** @type {(inputs: Cargo_Warehouse_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolsas en almacen`)
};

/**
* | output |
* | --- |
* | "Warehouse Bags" |
*
* @param {Cargo_Warehouse_BagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_warehouse_bags = /** @type {((inputs?: Cargo_Warehouse_BagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Warehouse_BagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_warehouse_bags(inputs)
	return es_cargo_warehouse_bags(inputs)
});